import Modal from "../../modal";
import IngredientsModal from "./ingredients-modal";
import React, {useEffect, useState} from "react";
import {getItem} from "../../../utils/communication";
import HFInput from "../../form/hf-input";
import HFSelect from "../../form/hf-select";

export interface RecipeIngredientData {
    recipeId?: string;
    ingredient?: Ingredient;
    ingredientId: string;
    amount: number;
    unit: number;
    deletedAt?: Date;
}

interface RecipeIngredientEditProps {
    ingredients: RecipeIngredientData[];
    setIngredients: (ingredients: RecipeIngredientData[]) => void;
}

export default function RecipeIngredientEdit(props: RecipeIngredientEditProps) {
    const [ingredientsModalShow, setIngredientsModalShow] = useState(false);

    const toggleIngredientsModalShow = () => {
        setIngredientsModalShow(!ingredientsModalShow)
    }

    const [allIngredients, setAllIngredients] = useState<Ingredient[]>([]);

    useEffect(() => {
        (async () => {
            let response = await getItem<Ingredient[]>("/cooking/ingredient/all");

            if (response.code === 200) {
                setAllIngredients(response.data as Ingredient[]);
            }
        })();
    }, []);

    const handleIngredientsChange = (ingredients: Ingredient[]) => {
        let result: RecipeIngredientData[] = [];
        for (let i of ingredients) {
            let found = props.ingredients.filter(ri => ri.ingredient?.publicId === i.publicId);

            if (found.length === 0) {
                result.push({
                    ingredient: i,
                    ingredientId: i.publicId,
                    amount: 0,
                    unit: 0
                });
            } else {
                result.push(found[0]);
            }
        }

        props.setIngredients(result);
    }

    const handleAmountChange = (publicId: string, value: string) => {
        let amount = parseFloat(value);
        if (isNaN(amount)) {
            amount = 0;
        }
        props.setIngredients(props.ingredients.map(rt => {
            if (rt.ingredientId === publicId) {
                rt.amount = amount;
            }

            return rt;
        }));
    }

    const handleUnitChange = (publicId: string, value: string) => {
        let unit = parseInt(value);
        props.setIngredients(props.ingredients.map(rt => {
            if (rt.ingredientId === publicId) {
                rt.unit = unit;
            }

            return rt;
        }));
    }

    return (<>
        <span onClick={toggleIngredientsModalShow}>Set Ingredients</span>

        <Modal title="Ingredients" visible={ingredientsModalShow}
               children={IngredientsModal(props.ingredients.map(ri => ri.ingredient!), handleIngredientsChange, allIngredients)}
               onClose={(state) => {
                   toggleIngredientsModalShow();
               }}/>

        <div>
            {props.ingredients.map((ri, index) => (
                <div key={index} className="flex justify-center items-center space-x-4">
                    <div className="w-32">{ri.ingredient?.name}</div>
                    <div className="flex-1 flex space-x-2">
                        <div className="flex-1">
                            <HFInput type="text" name={"ingredient_" + ri.ingredientId}
                                     value={ri.amount.toString()}
                                     onChange={(event) =>
                                         handleAmountChange(ri.ingredientId, event.target.value)}
                                     placeholder="0" label={undefined}/>
                        </div>
                        <div className="w-16">
                            <HFSelect name={"ingredient-unit-" + ri.ingredientId} value={ri.unit.toString()}
                                      onChange={(n, v) => handleUnitChange(ri.ingredientId, v)} label={undefined}
                                      options={[{label: "g", value: "0"}, {label: "mL", value: "1"}, {
                                          label: "x",
                                          value: "2"
                                      }]}/>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    </>);
}